import { gql } from "../__generated__";

export const GetObjectById = gql(`
  query GetByID(
    $where: ObjektWhereUniqueInput!
    $hydrateRelationships: Boolean!
  ) {
    object: objekt(where: $where) {
      title
      id
      typ {
        name
      }
      description {
        document(hydrateRelationships: $hydrateRelationships)
      }
      images {
        bild {
          url
          id
        }
        objekte {
          title
          id
          description {
            document(hydrateRelationships: $hydrateRelationships)
          }
          copyright {
            name
          }
          images {
            title
            name
          }
          periodOfOrigin {
            displayName
          }
          authorPerson {
            familyName
            givenName
            id
          }
          authorGroup {
            id
            bezeichnung
          }
          personsOnWork {
            familyName
            givenName
            id
          }
          groupsOnWork {
            id
            bezeichnung
          }
          locationOnWork {
            id
            name
          }
        }
      }
      imageObjects {
        id
        title
        images {
          bild {
            url
            id
          }
        }
      }
      periodOfOrigin {
        displayName
      }
      place {
        id
        name
      }
      dimensions
      ownerships {
        displayName
      }
      partOf {
        title
        id
        typ {
          name
        }
      }
      authorPerson {
        familyName
        givenName
        id
      }
      authorGroup {
        bezeichnung
        displayName
        id
      }
      contains {
        id
        title
      }
      weblinks {
        document
      }
      eigenschaftenMaterial {
        name
      }
      eigenschaftenTechnik {
        name
      }
      similarTo {
        id
        title
      }
      locationToday {
        id
        name
      }
      personsOnWork {
        familyName
        givenName
        id
      }
      groupsOnWork {
        id
        bezeichnung
      }
      locationOnWork {
        id
        name
      }
    }
  }
`);

export const GetObjects = gql(`
  query GetObjects($take: Int, $skip: Int, $orderBy: [ObjektOrderByInput!], $where: ObjektWhereInput, $hydrateRelationships: Boolean!) {
    count: objektsCount(where: $where)
    items: objekts(take: $take, skip: $skip, orderBy: $orderBy, where: $where) {
      id
      title
      images {
        bild {
          url
          id
        }
        objekte {
          title
          id
          description {
            document(hydrateRelationships: $hydrateRelationships)
          }
          copyright {
            name
          }
          images {
            title
            name
          }
          periodOfOrigin {
            displayName
          }
          authorPerson {
            familyName
            givenName
            id
          }
          authorGroup {
            id
            bezeichnung
          }
          personsOnWork {
            familyName
            givenName
            id
          }
          groupsOnWork {
            id
            bezeichnung
          }
          locationOnWork {
            id
            name
          }
        }
      }
      authorPerson {
        familyName
        givenName
        id
      }
      periodOfOrigin {
        displayName
        zeitspanne {
          von
          bis
        }
        datum
      }
      publisher
      pages
      imageObjects {
        id
        title
        images {
          displayName
          bild {
            url
            id
          }
        }
      }
    }
  }
`);
